import { useEffect, useState, useRef } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { useAuth } from '../../../hooks/useAuth';
registerLocale('es', es)

function Assignment() {
  const defaultWarningMessage = '¡Error al asignar boleto!.';
  const toast = useRef(null);
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [labels, setLabels] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [orderId, setOrderId] = useState('');
  const [address, setAddress] = useState('');
  const [serviceTypes, setServiceTypes] = useState([]);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [alertSuccessIsVisible, setAlertSuccessIsVisible] = useState(false);
  const [alertWarningIsVisible, setAlertWarningIsVisible] = useState(false);
  const [alertWarningMessage, setAlertWarningMessage] = useState(defaultWarningMessage);
  const [alertWarningMessage2, setAlertWarningMessage2] = useState('');
  const [loading, setLoading] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const defaultServiceType = 1;
  const defaultFilters = {
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'orderId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
  };
  const [filters, setFilters] = useState(defaultFilters);
  
  const onKeyPress = (e) => {
    // console.log("onKeyPress:", e.key);
    // if (e.key === "Enter") {
      
    // }
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    getDrivers();
    getVehicles();
    getLabels();
    getServiceTypes();

    document.addEventListener("keypress", onKeyPress);

    return () => {
      document.removeEventListener('keypress', onKeyPress);
    };
  }, []);

  const getDrivers = () => {
    fetch(`${process.env.REACT_APP_API_URL}/driver/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _drivers = data.responseObject;
          setDrivers(_drivers);
        }
      });
  };

  const getVehicles = () => {
    fetch(`${process.env.REACT_APP_API_URL}/vehicle/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _vehicles = data.responseObject;
          setVehicles(_vehicles);
        }
      });
  };

  const getLabels = () => {
    fetch(`${process.env.REACT_APP_API_URL}/label/cmb`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _drivers = data.responseObject;
          setLabels(_drivers);
        }
      });
  };  

  const getServiceTypes = () => {
    fetch(`${process.env.REACT_APP_API_URL}/order/cmbServiceType`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {
          const _serviceTypes = data.responseObject;          
          setServiceTypes(_serviceTypes);
          setDefaultServiceType(_serviceTypes);
        }
      });
  };  

  const setDefaultServiceType = (_serviceTypes) => {
    const defaultServiceTypeArray = _serviceTypes.filter(type => type.serviceTypeId === defaultServiceType);
    if (defaultServiceTypeArray.length > 0) {
      setSelectedServiceType(defaultServiceTypeArray[0]);
    }
  };
  
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  }
  
  const onOrderIdChange = (e) => {
    setOrderId(e.target.value);    
  }

  const onAddressChange = (e) => {
    setAddress(e.target.value);
  }

  const onServiceTypeChange = (e) => {
    setSelectedServiceType(e.value);    
  }

  const onDriverChange = (e) => {
    setSelectedDriver(e.value);
  }

  const onVehiclesChange = (e) => {
    setSelectedVehicle(e.value);
  }

  const onLabelChange = (e) => {
    setSelectedLabel(e.value);
  }  

  const resetAlerts = () => {
    setAlertWarningMessage(defaultWarningMessage);
    setAlertWarningMessage2('');
    setAlertWarningIsVisible(false);
    setAlertSuccessIsVisible(false);
  };

  const resetData = () => {
    setSelectedDriver(null);
    setSelectedVehicle(null);
    setSelectedLabel(null);    
    setFilters(defaultFilters);
    setOrders([]);
    setOrderId('');
    setAddress('');    
  };
  
  const onAssignClick = () => {    
    resetAlerts();
    assign(
      selectedDriver.driverId,
      selectedVehicle.vehicleId,
      selectedLabel ? selectedLabel.labelId : null,
      orders.map(order => ({
        orderId: order.orderId,
        address: order.address,
        serviceTypeId: order.serviceTypeId
      })),
      user.userId
    );
  }

  const assign = (
    driverId,
    vehicleId,
    labelId,
    orderIds,
    userId
  ) => {
    setAssigning(true);
    const orderId = '';
    fetch(`${process.env.REACT_APP_API_URL}/order/assignDriver`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        driverId,
        vehicleId,
        labelId,
        orderIds,
        orderId,
        userId
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        if (data.responseMessage === 'Success') {
          setAlertSuccessIsVisible(true);
          resetData();          
        } else {
          setAlertWarningMessage('');
          if (data.responseMessage !== '') setAlertWarningMessage(data.responseMessage);
          if (data.responseObject !== '') setAlertWarningMessage2(data.responseObject);
          setAlertWarningIsVisible(true);
        }        
      } else {
        setAlertWarningIsVisible(true);
      }
      setAssigning(false);
    }, (error) => {
      console.error(error);
      setAssigning(false);
    });
  }

  const onAddClick = () => {
    setLoading(true);
    if (orders.filter(e => e.orderId === orderId).length === 0) {
      const updatedOrders = [...orders, {
        orderId,
        address,
        serviceTypeId: selectedServiceType.serviceTypeId,
        serviceType: selectedServiceType.serviceType
      }];
      setOrders(updatedOrders);
      setOrderId('');
      setAddress('');
      setDefaultServiceType(serviceTypes);
    } else {
      showWarn();
    } 
    setLoading(false);
  }

  const showWarn = () => {
    toast.current.show({ severity: 'warn', summary: 'Duplicado', detail: 'La órden ya se encuentra agregada.', life: 3000 });
  }

  const reportHeaderTemplate = (
    <>
      <div className="flex justify-content-between align-items-center">
        <span className="p-input-icon-left">
          <i className="pi pi-filter" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Filtrar"
            id='orderIdInput'
            className='p-inputtext-sm'             
          />
        </span>
        &nbsp;
        <span className="p-input-icon-left">
          <i className="pi pi-qrcode" />
          <InputText
            value={orderId}
            onChange={onOrderIdChange}
            placeholder="Boleto"
            className='p-inputtext-sm'         
          />
        </span>
        &nbsp;
        <span className="p-input-icon-left">
          <i className="pi pi-map-marker" />
          <InputText
            value={address}
            onChange={onAddressChange}
            placeholder="Dirección"
            className='p-inputtext-sm'           
          />
        </span>
        &nbsp;
        <Dropdown
          value={selectedServiceType}
          options={serviceTypes}
          onChange={onServiceTypeChange}
          optionLabel="serviceType"
          placeholder="Selecciona el tipo de servicio"
          className='p-inputtext-sm'
        />
        &nbsp;
        <Button
          className='p-button-raised p-button-sm'
          label="Agregar boleto"
          aria-label="Agregar orden"
          onClick={onAddClick}
          disabled={orderId === ''}         
        />
      </div>
    </>
  );

  const reportTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Asignación
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Toast ref={toast} />
            <Alert
              key='success'
              variant='success'
              hidden={!alertSuccessIsVisible}>
              ¡Boletos asignadas correctamente!
            </Alert>
            <Alert
              key='warning'
              variant='warning'
              hidden={!alertWarningIsVisible}>              
              {
                alertWarningMessage !== '' && alertWarningMessage
              }
              {
                alertWarningMessage !== '' && alertWarningMessage2 !== '' &&
                (
                  <>
                    <br/>
                  </>
                ) 
              }
              {
                alertWarningMessage2 !== '' && alertWarningMessage2                
              }
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col>
            <Dropdown value={selectedDriver} options={drivers} onChange={onDriverChange} optionLabel="name" placeholder="Selecciona el chofer" className='p-inputtext-sm' />
            &nbsp;
            <Dropdown value={selectedVehicle} options={vehicles} onChange={onVehiclesChange} optionLabel="description" placeholder="Selecciona el vehículo" className='p-inputtext-sm' />
            &nbsp;
            <Dropdown value={selectedLabel} options={labels} onChange={onLabelChange} optionLabel="description" placeholder="Selecciona la etiqueta" className='p-inputtext-sm' />
            &nbsp;
            <Button
              className='p-button-raised p-button-sm'
              label={assigning ? 'Asignando...' : 'Asignar'}
              aria-label="Asignar"
              onClick={onAssignClick}
              disabled={!selectedDriver || !selectedVehicle || orders.length < 1 || assigning}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className='datatable-doc-demo'>
              <div className="card mt-3">
                <DataTable
                  value={orders}
                  className="p-datatable-customers"
                  showGridlines
                  stripedRows
                  header={reportHeaderTemplate}
                  filters={filters}
                  filterDisplay="menu"
                  loading={loading}
                  responsiveLayout="scroll"
                  globalFilterFields={[
                    'orderId',
                    'address',
                    'serviceType'
                  ]}
                  emptyMessage="Boletos"
                >
                  <Column field="orderId" header="Número de servicio" sortable filter filterPlaceholder="Buscar por Número de servicio" className='app-w-250-px text-end' />
                  <Column field="address" header="Dirección" sortable filter filterPlaceholder="Buscar por Dirección" className='app-w-350-px text-end' />
                  <Column field="serviceType" header="Tipo de servicio" sortable filter filterPlaceholder="Buscar por Tipo de servicio" className='app-w-150-px text-end' />
                </DataTable>
              </div>
            </div>
          </Col>
        </Row>
      </article>
    </>
  );

  return (
    <>
      {reportTemplate}
    </>
  );
}

export default Assignment;